var map = {
	"./about-dialog.action.ts": 28813,
	"./cashier-upload-documents.action.ts": 94167,
	"./chat.action.ts": 65407,
	"./com-points.action.ts": 15060,
	"./control-center.action.ts": 9626,
	"./deposit.action.ts": 57695,
	"./explore-navigation.action.ts": 9089,
	"./help-center.action.ts": 56260,
	"./hybrid-info.action.ts": 94938,
	"./inactivity-timeout-settings.action.ts": 4903,
	"./install-pwa.action.ts": 42967,
	"./loyalty-indicator.action.ts": 21651,
	"./my-club.action.ts": 10361,
	"./push-notifications-permissions-request.action.ts": 34985,
	"./reverse-withdrawal.action.ts": 22783,
	"./sign-up.action.ts": 15818,
	"./test-regulation-specific.action.ts": 70351,
	"./time-spent-reminder.action.ts": 84482,
	"./transaction-history.action.ts": 94258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69861;